export default function Visitanos() {
  return (
    <section id="visitanos" className="bg-md-light py-[72px] md:py-24">
      <div className="mx-auto flex max-w-[1200px] flex-col gap-12 px-6 md:flex-row md:gap-12 md:px-12">
        {/* Left Column - Info Card */}
        <div className="flex flex-1 items-start">
          <div className="w-full rounded-[20px] bg-white p-8 shadow-[0_4px_16px_rgba(15,31,53,0.12)] md:p-12">
            <h2 className="mb-8 font-serif text-[26px] font-bold text-md-ink md:text-[32px]">
              Punto físico en Pereira
            </h2>

            <div className="flex flex-col gap-6">
              <div className="flex items-start gap-4">
                <span className="flex h-5 w-5 flex-shrink-0 items-center justify-center pt-0.5 text-md-teal">
                  <i className="ri-map-pin-line" />
                </span>
                <div>
                  <span className="block text-[13px] font-semibold uppercase tracking-wide text-md-slate">
                    Dirección
                  </span>
                  <span className="mt-1 block text-[15px] font-medium text-md-ink md:text-[16px]">
                    Calle 24 # 19-18 Local 101 (Barrio Providencia), Pereira, Risaralda
                  </span>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <span className="flex h-5 w-5 flex-shrink-0 items-center justify-center pt-0.5 text-md-teal">
                  <i className="ri-phone-line" />
                </span>
                <div>
                  <span className="block text-[13px] font-semibold uppercase tracking-wide text-md-slate">
                    Teléfono
                  </span>
                  <a
                    href="tel:+573206789030"
                    className="mt-1 block text-[15px] font-medium text-md-ink transition-colors hover:text-md-dark md:text-[16px]"
                    onClick={() => {
                      if (typeof window !== 'undefined' && (window as unknown as Record<string, unknown>).mdCallClick) {
                        ((window as unknown as Record<string, unknown>).mdCallClick as () => void)();
                      }
                    }}
                  >
                    +57 320 678 9030
                  </a>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <span className="flex h-5 w-5 flex-shrink-0 items-center justify-center pt-0.5 text-md-teal">
                  <i className="ri-time-line" />
                </span>
                <div>
                  <span className="block text-[13px] font-semibold uppercase tracking-wide text-md-slate">
                    Horario
                  </span>
                  <span className="mt-1 block text-[15px] font-medium text-md-ink md:text-[16px]">
                    Lun–Vie: 8am–12pm, 2pm–5pm
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Right Column - Google Maps */}
        <div className="flex-1">
          <div className="h-[360px] w-full overflow-hidden rounded-2xl border border-md-sky md:h-full md:min-h-[420px]">
            <iframe
              title="Ubicación Multidroguerías Pereira"
              src="https://maps.google.com/maps?q=Calle+24+%2319-18+Local+101,+Pereira,+Risaralda,+Colombia&hl=es&z=17&ie=UTF8&iwloc=&output=embed"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              aria-label="Mapa de Calle 24 # 19-18 Local 101, Barrio Providencia, Pereira, Risaralda, Colombia"
            />
          </div>
        </div>
      </div>
    </section>
  );
}